module.exports = __webpack_public_path__ + "media/images/emblems/Martigny-Combe_flago-60d5ae6a6efae9e161a76799f291599e.png";